import { useState } from "react";
import { useCookies } from "react-cookie";

function Navbar(props) {
  const [cookies, setCookie, removeCookie] = useCookies();

  function changeColors(colors) {
    colors.forEach((color) => {
      document.documentElement.style.setProperty(color[0], color[1]);
    });
  }

  function changeThemeMode(value) {
    if (value == "light") {
      // For Light Theme
      changeColors([
        ["--primary-color", "#30475e"],
        ["--secondary-color", "#f05454"],
        ["--body-background-color", "#dddddd"],
        ["--body-color", "#222831"],
      ]);
    } else {
      // For Dark Theme
      // changeCookie(bool)
      changeColors([
        ["--primary-color", "#f05454"],
        ["--secondary-color", "#30475e"],
        ["--body-background-color", "#222831"],
        ["--body-color", "#dddddd"],
      ]);
    }
  }

  const onClick = (event) => {
    event.preventDefault(); // Prevent default page reload it was not necessary but i added hahahahahahahahahahahahahahhahahahah

    // If Light Mode cookie exists then lightMode else DarkMode
    if (!cookies.lightMode) {
      changeThemeMode("light");
      setCookie("lightMode", true, { secure: true /*, httpOnly: true */ });
    } else {
      removeCookie("lightMode", { secure: true /*, httpOnly: true */ });
      changeThemeMode("dark");
    }
  };

  // If lightmode present Change Theme
  if (cookies.lightMode) {
    changeThemeMode("light");
  }

  const navbarMobileIcon = "☰";

  function openNav(event) {
    event.preventDefault(); // Cancelling Default Page Reload on Click
    let open = event.target.innerText;

    if (open == navbarMobileIcon) {
      const menuMobile = document.getElementById("navbar-mobile-menu");
      menuMobile.classList.add("show");
      event.target.innerText = "x";
    } else {
      const menuMobile = document.getElementById("navbar-mobile-menu");
      menuMobile.classList.remove("show");
      event.target.innerText = navbarMobileIcon;
    }
  }

  return (
    <div className="navbar">
      <div className="navbar-desktop container flex">
        <div className="title">
          <h1 className="logo-heading">{props.Name}</h1>
        </div>
        <div className="menu">
          <ul className="menu-desktop flex">
            <li>
              <a href={props.GithubUrl} target="_blank">
                Github
              </a>
            </li>
            <li>
              <a href={props.LinkedinUrl} target="_blank">
                LinkedIn
              </a>
            </li>
            <li>
              <a href="#projects">Projects</a>
            </li>
            <li>
              <a href="#contact">Contact</a>
            </li>
            <li id="changeModeBtn" onClick={onClick}>
              {!cookies.lightMode ? "☼" : "☾"}
            </li>
          </ul>
        </div>
      </div>

      <div className="navbar-mobile relative">
        <div className="menu-mobile flex relative">
          <h1 className="logo-heading">{props.Name}</h1>
          <button id="open-nav-btn" onClick={openNav}>
            {navbarMobileIcon}
          </button>
          <div id="navbar-mobile-menu">
            <ul id="mobile-menu">
              <li>
                <a href={props.GithubUrl} target="_blank">
                  Github
                </a>
              </li>
              <li>
                <a href={props.LinkedinUrl} target="_blank">
                  LinkedIn
                </a>
              </li>
              <li>
                <a href="#projects">Projects</a>
              </li>
              <li>
                <a href="#contact">Contact</a>
              </li>
              <li id="changeModeBtn" onClick={onClick}>
                {!cookies.lightMode ? "☼" : "☾"}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
